import { render, staticRenderFns } from "./HeaderTitles.vue?vue&type=template&id=ff2d404c&scoped=true&"
import script from "./HeaderTitles.vue?vue&type=script&lang=js&"
export * from "./HeaderTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2d404c",
  null
  
)

export default component.exports